export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";